const roomEvents = {
  openRoom: {
    action: "open-room",
    label: (clickSource, sceneId) => `${clickSource}:${sceneId}`,
  },
  openSavedRoom: {
    action: "open-saved-room",
    label: (clickSource, sceneId) => `${clickSource}:${sceneId}`,
  },
  deleteSavedRoom: {
    action: "delete-saved-room",
    label: (clickSource, sceneId) => `${clickSource}:${sceneId}`,
  },
  renameSavedRoom: {
    action: "rename-saved-room",
    label: (clickSource, sceneId) => `${clickSource}:${sceneId}`,
  },
};

export default roomEvents;
